import React from 'react';
import { Create } from 'react-admin';

import DisclaimerForm from '../DisclaimerForm';

function DisclaimerCreate({ ...props }) {
  return (
    <Create {...props}>
      <DisclaimerForm redirect="list" />
    </Create>
  );
}

export default DisclaimerCreate;
